import { PageTitle } from "@/components/page-title";
import { MerchantForm } from "./_form";
import { Merchant, PropsWithUser } from "@/types";

type Props = {
  merchant: Merchant;
};

function MerchantShow({ merchant }: PropsWithUser<Props>) {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <PageTitle>Edit merchant</PageTitle>
      <MerchantForm merchant={merchant} />
    </div>
  );
}

export default MerchantShow;
